// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2u1rd","image":"Header_image__10mrh","name":"Header_name__1I4jl","info":"Header_info__6SCiT","infoRow":"Header_infoRow__3GYLi"};